import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import ReactGA from 'react-ga4';

import {
	Button,
	ButtonGroup,
	Card,
	CardHeader,
	CardBody,
	Col,
	Container,
	Form,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Row,
	UncontrolledTooltip
} from 'reactstrap';

import { Bar } from 'react-chartjs-2';
import { Crumbs } from 'containers';
import {
	fetchProductionFactors,
	resetProductionFactors,
	fetchAlSmelterProduction,
	resetAlSmelterProduction,
	fetchAlMtdProduction,
	resetAlMtdProduction,
	fetchAlProductionBySmelter,
	resetAlProductionBySmelter,
	selectAlProdSmelter,
	resetAlProdSmelters
} from 'actions';
import PeriodButtonGroup from './components/PeriodButtonGroup';
import RangeButtonGroup from './components/RangeButtonGroup';
import SmelterList from './components/SmelterList';
import {
	DATE_MIN,
	CURR_CAL_YEAR_START,
	PREV_CAL_YEAR_START,
	PREV_5_CAL_YEARS_START,
	PREV_3_CAL_YEARS_START,
	YEAR_COLOURS,
	MAIN_VIEW,
	SMELTERS_VIEW,
	YEARS_VIEW
} from './config';
import { generateRandomColours, groupByKey } from '../../../utils';
import colours from '../../../_colours.scss';
import './SmeltersProduction.scss';

const apiDateFormat = 'YYYYMMDD';

class SmeltersProduction extends Component {
	state = {
		selectedRegion: 'australia',
		selectedPeriod: 'monthly',
		startDate: DATE_MIN,
		ute: '',
		isUteEditing: false,
		capAdd: '',
		isCapAddEditing: false,
		rightButtonsSelected: MAIN_VIEW,
		smelterColours: [],
		startDateSmelters: CURR_CAL_YEAR_START,
		selectedPeriodSmelters: 'monthly',
		showYearsQuarterly: false,
		showStackedYears: false,
		capAddEnabled: true
	};

	constructor(props) {
		super(props);
		this.smeltersRef = React.createRef();
		this.yearsRef = React.createRef();
	}

	async componentDidMount() {
		this.props.fetchProductionFactors({ commodity: 'al' });
	}

	componentDidUpdate(
		{
			regions: prevRegions,
			pseudoGroupSmelters: prevPseudoGroupSmelters,
			production: prevProduction,
			alSelectedProdSmelters: prevSelectedProdSmelters
		},
		{
			selectedRegion: prevselectedRegion,
			selectedPeriod: prevSelectedPeriod,
			startDate: prevStartDate,
			isUteEditing: isPrevUteEditing,
			capAddEnabled: prevCapAddEnabled,
			selectedPeriodSmelters: prevSelectedPeriodSmelters,
			startDateSmelters: prevStartDateSmelters,
			rightButtonsSelected: prevRightButtonsSelected,
			showYearsQuarterly: prevShowYearsQuarterly
		}
	) {
		const {
			selectedRegion,
			selectedPeriod,
			startDate,
			isUteEditing,
			ute,
			selectedPeriodSmelters,
			startDateSmelters,
			rightButtonsSelected,
			showYearsQuarterly
		} = this.state;

		const { regions, production, alSelectedProdSmelters, pseudoGroupSmelters } =
			this.props;

		const effectiveCapAdd = this.state.capAddEnabled ? '' : 0;

		if (regions.length > prevRegions.length) {
			const current = regions.find(({ key }) => key === selectedRegion);
			const { grouping, id } = current;
			const defUte = this.getDefaultUte();
			this.setState({
				ute: defUte
			});
			let params = {
				grouping: grouping === 'global' ? '' : grouping,
				id,
				collapse: selectedPeriod,
				ute: defUte,
				capAdd: effectiveCapAdd,
				startDate: startDate.format(apiDateFormat)
			};
			if (grouping && grouping !== 'global') {
				params = { ...params, id };
			}
			this.props.fetchAlSmelterProduction(params);
		}

		if (selectedRegion !== prevselectedRegion) {
			const capAvailable = this.isCapAddAvailable();

			this.setState({
				capAddEnabled: capAvailable ? this.state.capAddEnabled : false
			});
			const defUte = this.getDefaultUte();
			this.setState({
				ute: defUte,
				rightButtonsSelected: MAIN_VIEW,
				showYearsQuarterly: false,
				showStackedYears: false,
				startDate: DATE_MIN,
				selectedPeriod: 'monthly',
				capAddEnabled: true
			});
			this.props.resetAlProdSmelters();
			this.props.resetAlProductionBySmelter();
			this.props.resetAlMtdProduction();
			this.props.resetAlSmelterProduction();
		}

		if (
			(!isUteEditing && isUteEditing !== isPrevUteEditing) ||
			this.state.capAddEnabled !== prevCapAddEnabled
		) {
			const current = regions.find(({ key }) => key === selectedRegion);
			const { grouping, id } = current;

			let params = {
				grouping: grouping === 'global' ? '' : grouping,
				collapse: selectedPeriod,
				ute,
				capAdd: effectiveCapAdd,
				startDate: startDate.format(apiDateFormat)
			};
			if (grouping && grouping !== 'global') {
				params = { ...params, id };
			}
			this.props.fetchAlSmelterProduction(params);

			if (
				rightButtonsSelected === YEARS_VIEW &&
				((!showYearsQuarterly && selectedPeriod !== 'monthly') ||
					(showYearsQuarterly && selectedPeriod !== 'quarterly'))
			) {
				let params = {
					grouping,
					collapse: `${showYearsQuarterly ? 'quarterly' : 'monthly'}`,
					startDate: startDate.format(apiDateFormat),
					ute,
					capAdd: effectiveCapAdd
				};
				if (grouping) {
					params = { ...params, id };
				}
				this.props.fetchAlSmelterProduction(params);
			}

			if (rightButtonsSelected === SMELTERS_VIEW && isPrevUteEditing) {
				let params = {
					grouping,
					ute
				};
				if (grouping) {
					params = { ...params, id };
				}
				this.props.fetchAlMtdProduction(params);
				this.props.fetchAlProductionBySmelter({
					ids: [...alSelectedProdSmelters],
					ute,
					collapse: selectedPeriodSmelters,
					startDate: startDateSmelters.format(apiDateFormat)
				});
			}
		}

		if (
			(Object.keys(prevProduction).length !== 0 &&
				Object.keys(production).length === 0) ||
			selectedPeriod !== prevSelectedPeriod ||
			startDate !== prevStartDate
		) {
			const current = regions.find(({ key }) => key === selectedRegion);
			const { grouping, id } = current;

			let params = {
				grouping: grouping === 'global' ? '' : grouping,
				collapse: selectedPeriod,
				startDate: startDate.format(apiDateFormat),
				ute,
				capAdd: effectiveCapAdd
			};
			if (grouping && grouping !== 'global') {
				params = { ...params, id };
			}
			this.props.fetchAlSmelterProduction(params);

			if (
				rightButtonsSelected === YEARS_VIEW &&
				((!showYearsQuarterly && selectedPeriod !== 'monthly') ||
					(showYearsQuarterly && selectedPeriod !== 'quarterly')) &&
				startDate !== prevStartDate
			) {
				let params = {
					grouping,
					collapse: `${showYearsQuarterly ? 'quarterly' : 'monthly'}`,
					startDate: startDate.format(apiDateFormat),
					ute,
					capAdd: effectiveCapAdd
				};
				if (grouping) {
					params = { ...params, id };
				}
				this.props.fetchAlSmelterProduction(params);
			}
		}

		if (
			!prevPseudoGroupSmelters.length &&
			pseudoGroupSmelters.length &&
			!alSelectedProdSmelters.length &&
			!prevSelectedProdSmelters.length
		) {
			this.setState({
				smelterColours: this.generateSmelterColours()
			});
			this.props.selectAlProdSmelter(pseudoGroupSmelters[0].id);
		} else if (
			!alSelectedProdSmelters.length &&
			prevSelectedProdSmelters.length
		) {
			this.props.resetAlProductionBySmelter();
		} else if (
			alSelectedProdSmelters.length !== prevSelectedProdSmelters.length ||
			(rightButtonsSelected === SMELTERS_VIEW &&
				(selectedPeriodSmelters !== prevSelectedPeriodSmelters ||
					startDateSmelters !== prevStartDateSmelters))
		) {
			this.props.fetchAlProductionBySmelter({
				ids: [...alSelectedProdSmelters],
				ute,
				collapse: selectedPeriodSmelters,
				startDate: startDateSmelters.format(apiDateFormat)
			});
		}

		if (rightButtonsSelected !== prevRightButtonsSelected) {
			if (rightButtonsSelected === SMELTERS_VIEW) {
				const current = regions.find(({ key }) => key === selectedRegion);
				const { grouping, id } = current;

				let params = {
					grouping: grouping === 'global' ? '' : grouping,
					ute
				};
				if (grouping && grouping !== 'global') {
					params = { ...params, id };
				}

				!alSelectedProdSmelters.length &&
					this.props.fetchAlMtdProduction(params);

				alSelectedProdSmelters.length !== 0 &&
					this.props.fetchAlProductionBySmelter({
						ids: [...alSelectedProdSmelters],
						ute,
						collapse: selectedPeriodSmelters,
						startDate: startDateSmelters.format(apiDateFormat)
					});

				this.smeltersRef.current.scrollIntoView();
			} else if (rightButtonsSelected === YEARS_VIEW) {
				const current = regions.find(({ key }) => key === selectedRegion);
				const { grouping, id } = current;

				let params = {
					grouping: grouping === 'global' ? '' : grouping,
					collapse: selectedPeriod,
					startDate: startDate.format(apiDateFormat),
					ute,
					capAdd: effectiveCapAdd
				};
				if (grouping && grouping !== 'global') {
					params = { ...params, id };
				}
				this.props.fetchAlSmelterProduction(params);

				this.yearsRef.current.scrollIntoView();
			}

			if (prevRightButtonsSelected === SMELTERS_VIEW) {
				this.setState({
					startDateSmelters: CURR_CAL_YEAR_START,
					selectedPeriodSmelters: 'monthly'
				});
				this.props.resetAlMtdProduction();
				this.props.resetAlProductionBySmelter();
				this.props.resetAlProdSmelters();
			} else if (prevRightButtonsSelected === YEARS_VIEW) {
				this.setState({ showStackedYears: false });
			}
		}

		if (showYearsQuarterly !== prevShowYearsQuarterly) {
			const current = regions.find(({ key }) => key === selectedRegion);
			const { grouping, id } = current;

			let params = {
				grouping: grouping === 'global' ? '' : grouping,
				collapse: `${showYearsQuarterly ? 'quarterly' : 'monthly'}`,
				startDate: startDate.format(apiDateFormat),
				ute,
				capAdd: effectiveCapAdd
			};
			if (grouping && grouping !== 'global') {
				params = { ...params, id };
			}
			this.props.fetchAlSmelterProduction(params);
		}
	}

	componentWillUnmount() {
		this.props.resetProductionFactors();
		this.props.resetAlProductionBySmelter();
		this.props.resetAlMtdProduction();
		this.props.resetAlSmelterProduction();
		this.props.resetAlProdSmelters();
	}

	getDefaultUte = () => {
		const { selectedRegion } = this.state;
		const { regions } = this.props;
		return regions.find(({ key }) => key === selectedRegion).ute;
	};

	onInputSelect = ({ target: { options } }) => {
		const selectedIdx = options.selectedIndex;

		this.setState({
			selectedRegion: options[selectedIdx].getAttribute('data-key')
		});
	};

	getDisplayCapAdd = () => {
		const { selectedRegion } = this.state;
		const { regions } = this.props;

		const region = regions.find(({ key }) => key === selectedRegion);

		if (!region || !region.cap_add) return 'N/A';

		const values = region.cap_add.map((c) => Number(c.tonnage));
		const allZero = values.every((v) => v === 0);

		if (allZero) return '0 (kt)';

		const uniqueValues = [...new Set(values)];

		if (uniqueValues.length === 1) {
			return `${uniqueValues[0]} (kt)`;
		}

		const min = Math.min(...values);
		const max = Math.max(...values);

		return `${min}–${max} (kt)`;
	};

	getCapAddTooltipContent = () => {
		const { selectedRegion } = this.state;
		const { regions } = this.props;

		const region = regions.find(({ key }) => key === selectedRegion);
		if (!region || !region.cap_add) {
			return <div>No extra capacity available</div>;
		}

		return (
			<div>
				{region.cap_add.map(({ start, end, tonnage }, index) => (
					<div key={index}>
						{start} → {end === 'infinity' ? '∞' : end}: {tonnage} kt
					</div>
				))}
			</div>
		);
	};

	isCapAddAvailable = () => {
		const { selectedRegion } = this.state;
		const { regions } = this.props;

		const region = regions.find(({ key }) => key === selectedRegion);
		if (!region || !region.cap_add) return false;

		const values = region.cap_add.map((c) => Number(c.tonnage));
		return !values.every((v) => v === 0);
	};

	toggleUteEditing = () => {
		const { isUteEditing } = this.state;
		this.setState({ isUteEditing: !isUteEditing });
	};

	toggleCapAddEditing = () => {
		const { isCapAddEditing } = this.state;
		this.setState({ isCapAddEditing: !isCapAddEditing });
	};
	toggleCapAddEnabled = () => {
		this.setState((prevState) => ({
			capAddEnabled: !prevState.capAddEnabled
		}));
	};

	onUteChange = ({ target: { value, min, max } }) => {
		const val = Math.max(Number(min), Math.min(Number(max), Number(value)));
		this.setState({ ute: val });
	};
	onUteBlur = () => {
		const { ute } = this.state;
		this.toggleUteEditing();
		ute === 0
			? this.setState({
					ute: this.getDefaultUte()
				})
			: this.setState({ ute: Number.parseFloat(ute).toFixed(2) });
	};

	onBtnClick = ({ target: { id } }) => {
		switch (id) {
			case 'main-monthly':
				this.setState({ selectedPeriod: 'monthly' });
				break;
			case 'main-quarterly':
				this.setState({ selectedPeriod: 'quarterly' });
				break;
			case 'main-year':
				this.setState({ selectedPeriod: 'annual' });
				break;
			case 'main-0Y':
				this.setState({ startDate: CURR_CAL_YEAR_START });
				break;
			case 'main-1Y':
				this.setState({ startDate: PREV_CAL_YEAR_START });
				break;
			case 'main-3Y':
				this.setState({ startDate: PREV_3_CAL_YEARS_START });
				break;
			case 'main-5Y':
				this.setState({ startDate: PREV_5_CAL_YEARS_START });
				break;
			case 'main-all':
				this.setState({ startDate: DATE_MIN });
				break;
			case 'bottom-monthly':
				this.setState({ selectedPeriodSmelters: 'monthly' });
				break;
			case 'bottom-quarterly':
				this.setState({ selectedPeriodSmelters: 'quarterly' });
				break;
			case 'bottom-year':
				this.setState({ selectedPeriodSmelters: 'annual' });
				break;
			case 'bottom-0Y':
				this.setState({ startDateSmelters: CURR_CAL_YEAR_START });
				break;
			case 'bottom-1Y':
				this.setState({ startDateSmelters: PREV_CAL_YEAR_START });
				break;
			case 'bottom-5Y':
				this.setState({ startDateSmelters: PREV_5_CAL_YEARS_START });
				break;
			case 'bottom-3Y':
				this.setState({ startDateSmelters: PREV_3_CAL_YEARS_START });
				break;
			default:
				return false;
		}
	};

	toggleView = (view) => {
		const { rightButtonsSelected } = this.state;
		if (rightButtonsSelected !== view) {
			this.setState({ rightButtonsSelected: view });
		} else {
			this.setState({ rightButtonsSelected: MAIN_VIEW });
		}
	};

	// Build csv data from the props for the download feature
	getCsvDataFromProps() {
		const { production, regions } = this.props;
		const { selectedRegion, selectedPeriod, startDate, ute, capAdd } =
			this.state;

		if (!this.regionDataAvailable()) {
			return {
				csvFileName: '',
				csvHeaders: [],
				csvData: []
			};
		}

		// Initialise our csv data
		const csvFileName = `al-production-${selectedRegion}-${selectedPeriod}-from-${startDate.format(
			'YYYY'
		)}.csv`;
		const csvHeaders = [
			{
				label: `${selectedPeriod[0].toUpperCase()}${selectedPeriod.slice(1)}`,
				key: 't'
			},
			{ label: 'Production (kt)', key: 'p' },
			{ label: `UTE: ${ute}`, key: '' },
			{ label: `Extra Capacity: ${capAdd}%`, key: '' }
		];

		const csvData = production[selectedPeriod][
			regions.find(({ key }) => key === selectedRegion).name
		].data.map(({ t, p }) => ({ t, p }));

		return {
			csvFileName,
			csvHeaders,
			csvData
		};
	}

	buildCsvDownloadButton() {
		const { csvHeaders, csvData, csvFileName } = this.getCsvDataFromProps();
		const { isUteEditing, isCapAddEditing } = this.state;
		if (csvData.length !== 0 && !isUteEditing && !isCapAddEditing) {
			return (
				<CSVLink
					id="buttonDownload"
					filename={csvFileName}
					headers={csvHeaders}
					data={csvData}
					className="btn btn-success mb-3 pull-right btn-sm"
					onClick={() => {
						ReactGA.event({
							category: 'production',
							action: 'data downloaded',
							label: csvFileName
						});
						return true;
					}}
				>
					<i className="fa fa-download mr-2" aria-hidden="true" /> Download this
					data
				</CSVLink>
			);
		}

		return (
			<Button
				id="buttonDownload"
				color="success"
				disabled
				className="btn btn-success mb-3 pull-right btn-sm"
				size="sm"
			>
				<i className="fa fa-download mr-2" aria-hidden="true" /> Download this
				data
			</Button>
		);
	}
	buildFilterForm() {
		const {
			selectedRegion,
			ute,
			capAddEnabled,
			rightButtonsSelected,
			startDate,
			selectedPeriod
		} = this.state;

		const { regions } = this.props;

		if (!regions.length) return null;

		const countryRegions = regions.filter((r) => r.grouping === 'countries');
		const otherRegions = regions.filter((r) => r.grouping !== 'countries');

		return (
			<Form className="mb-3" onSubmit={(e) => e.preventDefault()}>
				<Row className="align-items-center">
					{/* LEFT SIDE */}
					<Col xs="12" xl="9" className="pr-xl-3">
						<div className="d-flex flex-wrap flex-xl-nowrap align-items-center">
							{/* Region */}
							<div className="d-flex align-items-center mr-2 mb-2 mb-xl-0">
								<Input
									id="region"
									name="region"
									type="select"
									bsSize="sm"
									style={{ maxWidth: '170px' }}
									value={
										regions.find(({ key }) => key === selectedRegion)?.name ||
										''
									}
									onChange={this.onInputSelect}
								>
									<option disabled>Country</option>

									{countryRegions.map(({ key, name }) => (
										<option key={key} data-key={key} value={name}>
											{name}
										</option>
									))}

									{!!otherRegions.length && (
										<option disabled>Other Regions</option>
									)}

									{otherRegions.map(({ key, name }) => (
										<option key={key} data-key={key} value={name}>
											{name}
										</option>
									))}
								</Input>
							</div>

							{/* UTE + XTRA */}
							<div className="d-flex align-items-center mr-2 mb-2 mb-xl-0">
								<InputGroup
									size="sm"
									style={{ width: 'auto', whiteSpace: 'nowrap' }}
								>
									<InputGroupAddon addonType="prepend">
										<InputGroupText>
											UTE ({this.getDefaultUte()})
										</InputGroupText>
									</InputGroupAddon>

									<Input
										style={{ width: '4.5rem' }}
										id="ute"
										type="number"
										name="ute"
										value={ute ?? ''} // ensures controlled input always has string
										max="99"
										min="0"
										step="0.01"
										placeholder="0.00"
										onFocus={this.toggleUteEditing}
										onChange={this.onUteChange}
										onBlur={this.onUteBlur}
										onKeyDown={(e) => {
											if (e.key === 'Enter') e.target.blur();
										}}
									/>

									<InputGroupAddon addonType="prepend">
										<InputGroupText id="xtraTooltip">
											XTRA: {this.getDisplayCapAdd()}
										</InputGroupText>
										{this.isCapAddAvailable() && (
											<UncontrolledTooltip
												placement="top"
												delay={500}
												target="xtraTooltip"
												trigger="hover"
											>
												{this.getCapAddTooltipContent()}
											</UncontrolledTooltip>
										)}
									</InputGroupAddon>

									<Input
										id="capAddToggle"
										style={{
											width: '3.5rem',
											textAlign: 'center',
											cursor: this.isCapAddAvailable()
												? 'pointer'
												: 'not-allowed',
											backgroundColor: this.isCapAddAvailable()
												? '#fff'
												: '#dee2e6', // darker gray for disabled
											color: this.isCapAddAvailable() ? '#212529' : '#6c757d', // dark vs muted text
											fontWeight: this.isCapAddAvailable() ? 'bold' : 'normal',
											border: this.isCapAddAvailable()
												? '1px solid #ced4da'
												: '1px solid #adb5bd'
										}}
										type="text"
										readOnly
										value={capAddEnabled ? 'ON' : 'OFF'}
										disabled={!this.isCapAddAvailable()} // disable when XTRA is 0kt
										onClick={() => {
											if (this.isCapAddAvailable()) {
												this.toggleCapAddEnabled();
											}
										}}
									/>
									<UncontrolledTooltip
										placement="top"
										delay={500}
										target="capAddToggle"
										trigger="click hover"
									>
										{this.isCapAddAvailable()
											? capAddEnabled
												? 'Click to disable extra capacity'
												: 'Click to enable extra capacity'
											: 'Extra capacity not available'}
									</UncontrolledTooltip>
								</InputGroup>
							</div>

							{/* Period Buttons */}
							<div
								className="mr-2 mb-2 mb-xl-0"
								style={{ whiteSpace: 'nowrap' }}
							>
								<PeriodButtonGroup
									ids={['main-monthly', 'main-quarterly', 'main-year']}
									collapse={selectedPeriod}
									onClick={this.onBtnClick}
								/>
							</div>

							{/* Range Buttons */}
							<div
								className="mr-2 mb-2 mb-xl-0"
								style={{ whiteSpace: 'nowrap' }}
							>
								<RangeButtonGroup
									ids={['main-0Y', 'main-1Y', 'main-3Y', 'main-5Y', 'main-all']}
									start={startDate}
									onClick={this.onBtnClick}
								/>
							</div>
						</div>
					</Col>

					{/* RIGHT SIDE */}
					<Col
						xs="12"
						xl="3"
						className="d-flex justify-content-xl-end align-items-center mt-2 mt-xl-0 pl-xl-2"
					>
						<ButtonGroup>
							<Button
								outline
								size="sm"
								color="secondary"
								onClick={() => this.toggleView(SMELTERS_VIEW)}
								active={rightButtonsSelected === SMELTERS_VIEW}
								className="mr-1"
								disabled={Number(ute) === 0}
							>
								Smelters
							</Button>

							<Button
								outline
								size="sm"
								color="secondary"
								onClick={() => this.toggleView(YEARS_VIEW)}
								active={rightButtonsSelected === YEARS_VIEW}
								className="mr-1"
							>
								Compare
							</Button>

							<Button outline size="sm" color="secondary" disabled>
								Prediction
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
			</Form>
		);
	}
	buildCardHeader() {
		const title = 'Production data for selected region';

		return (
			<CardHeader>
				<i className="fa fa-bar-chart" aria-hidden="true" /> {title}
			</CardHeader>
		);
	}

	getDefaultChartOptions() {
		return {
			responsive: true,
			hover: { mode: null },
			scales: {
				yAxes: [
					{
						distribution: 'linear',
						position: 'left',
						scaleLabel: {
							display: true,
							labelString: 'Production (kt)'
						},
						ticks: {
							beginAtZero: true
						}
					}
				]
			}
		};
	}
	buildMainView() {
		const { production, regions } = this.props;
		const { selectedRegion, selectedPeriod } = this.state;

		if (!this.regionDataAvailable()) return;

		const options = this.getDefaultChartOptions();
		const regionData = production[selectedPeriod];

		const ptData = regionData.map(({ p }) => p);
		const labels = regionData.map(({ t }) => t);
		const pg = regions.find(({ key }) => key === selectedRegion);

		const barData = {
			labels,
			datasets: [
				{
					label: pg.name,
					data: ptData,
					backgroundColor: colours.savantNickel
				}
			]
		};

		return (
			<Card className="mb-3">
				{this.buildCardHeader()}
				<CardBody>
					<Container fluid>
						<Row noGutters className="mt-0">
							<Col xs="12" sm="12">
								<Bar data={{ ...barData }} options={options} />
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		);
	}

	buildSmelterCardHeader() {
		const { selectedRegion, ute } = this.state;
		const { regions } = this.props;
		const name = regions.find(({ key }) => key === selectedRegion).name;
		const title = `Production data for ${name} smelters, UTE:${ute}`;

		return (
			<CardHeader>
				<i className="fa fa-bar-chart" aria-hidden="true" /> {title}
			</CardHeader>
		);
	}

	generateSmelterColours = () => {
		const { pseudoGroupSmelters } = this.props;
		return generateRandomColours(pseudoGroupSmelters.length);
	};

	buildSmelterBarChart() {
		const { productionSmelters, pseudoGroupSmelters } = this.props;
		const { smelterColours } = this.state;

		const options = this.getDefaultChartOptions();

		const labels = Object.keys(productionSmelters);
		const datasets = Object.values(productionSmelters).map(({ data }, i) => ({
			label: labels[i],
			data: data.map(({ p }) => p),
			backgroundColor:
				smelterColours[
					pseudoGroupSmelters.findIndex(({ name }) => name === labels[i])
				]
		}));
		const barData = {
			//all arrays are of the same length
			labels: Object.values(productionSmelters)
				.map(({ data }) => data)[0]
				.map(({ t }) => t),
			datasets
		};

		return <Bar data={{ ...barData }} options={options} />;
	}
	buildSmelterView() {
		const { productionSmelters } = this.props;
		const { startDateSmelters, selectedPeriodSmelters } = this.state;

		const smeltersDataAvailable = Object.keys(productionSmelters).length !== 0;

		return (
			<Card className="mb-3" innerRef={this.smeltersRef}>
				{this.buildSmelterCardHeader()}
				<CardBody>
					<Container fluid className="smelter-container">
						<Row noGutters className="mb-2 mt-2 justify-content-end">
							<PeriodButtonGroup
								groupClass="mr-2"
								ids={[
									'bottom-monthly',
									'bottom-quarterly',
									'bottom-year',
									'bottom-3Y'
								]}
								collapse={selectedPeriodSmelters}
								disabled={!smeltersDataAvailable}
								onClick={this.onBtnClick}
							/>
							<RangeButtonGroup
								groupClass="mr-2"
								ids={['bottom-0Y', 'bottom-1Y', 'bottom-3Y', 'bottom-5Y']}
								start={startDateSmelters}
								onClick={this.onBtnClick}
								disabled={!smeltersDataAvailable}
							/>
						</Row>
						<Row noGutters className="mt-0">
							<Col xs="3" xl="2" className="smelter-list-panel">
								<SmelterList />
							</Col>
							<Col xs="9" xl="10" className="pl-3">
								{smeltersDataAvailable && this.buildSmelterBarChart()}
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		);
	}

	toggleYearsChartView = () => {
		const { showStackedYears } = this.state;
		this.setState({ showStackedYears: !showStackedYears });
	};
	toggleYearsScope = () => {
		const { showYearsQuarterly } = this.state;
		this.setState({ showYearsQuarterly: !showYearsQuarterly });
	};
	buildYearsCardHeader() {
		const { selectedRegion, showYearsQuarterly, ute, capAdd } = this.state;
		const { regions } = this.props;
		const name = regions.find(({ key }) => key === selectedRegion).name;
		const title = `Production ${
			showYearsQuarterly ? 'quarterly' : 'monthly'
		} comparison for ${name}, UTE:${ute}, Extra Capacity: ${capAdd}% `;

		return (
			<CardHeader>
				<i className="fa fa-bar-chart" aria-hidden="true" /> {title}
			</CardHeader>
		);
	}
	regionDataAvailable = (collapse = '') => {
		const { selectedPeriod } = this.state;
		const { regions, production } = this.props;
		const givenPeriod = collapse ? collapse : selectedPeriod;

		if (production) {
			return (
				Object.keys(production).length !== 0 &&
				production.hasOwnProperty(givenPeriod) &&
				regions.length !== 0
				// &&
				// production[givenPeriod].name ===
				// 	regions.find(({ key }) => key === selectedRegion).name
			);
		}
		return false;
	};
	buildYearsView = () => {
		const { showYearsQuarterly, showStackedYears, startDate } = this.state;
		const { production } = this.props;
		const isQuarterly =
			showYearsQuarterly && this.regionDataAvailable('quarterly');
		const collapse = `${isQuarterly ? 'quarterly' : 'monthly'}`;
		const data = production[collapse].map(({ t, p }) => ({
			year: isQuarterly ? t.substr(2) : moment.utc(t).format('YYYY'),
			monthly: !showYearsQuarterly ? moment.utc(t).format('MMM') : '',
			quarterly: isQuarterly ? `Q${t.substr(0, 1)}` : '',
			p
		}));

		const datasets = groupByKey(data, 'year');
		const years = Object.keys(datasets);

		const yearData = Object.values(datasets);

		//labels for each dataset are identical
		const labels = !showYearsQuarterly
			? yearData[0].map(({ monthly }) => monthly)
			: yearData[0].map(({ quarterly }) => quarterly);
		const chartDatasets = yearData.map((yd, i) => ({
			label: years[i],
			data: yd.map(({ p }) => p),
			backgroundColor: YEAR_COLOURS.find(({ year }) => year === years[i]).colour
		}));

		const defaultOptions = this.getDefaultChartOptions();

		const options = {
			...defaultOptions,
			scales: {
				...defaultOptions.scales,
				yAxes: defaultOptions.scales.yAxes.map((ya) => ({
					...ya,
					stacked: showStackedYears ? true : false
				})),
				xAxes: [
					{
						stacked: showStackedYears ? true : false
					}
				]
			}
		};

		const barData = {
			labels,
			datasets: chartDatasets
		};

		return (
			<Card className="mb-3" innerRef={this.yearsRef}>
				{this.buildYearsCardHeader()}
				<CardBody>
					<Container fluid>
						<Row noGutters className="mb-2 mt-2 justify-content-end">
							<Button
								id="chart-type"
								outline
								size="sm"
								color="secondary"
								onClick={this.toggleYearsScope}
								aria-label={'Chart type'}
								className="mr-2 light-active-border"
							>
								{showYearsQuarterly ? 'Monthly' : 'Quarterly'}
							</Button>
							<Button
								id="chart-type"
								outline
								size="sm"
								color="secondary"
								onClick={this.toggleYearsChartView}
								aria-label={'Chart type'}
								className="light-active-border"
								disabled={moment.utc().diff(startDate, 'years') < 1}
							>
								{showStackedYears ? 'Parallel View' : 'Stacked View'}
							</Button>
						</Row>
						<Row noGutters className="mt-0">
							<Col xs="12" sm="12">
								<Bar data={{ ...barData }} options={options} />
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		);
	};

	buildBottomView = () => {
		const { rightButtonsSelected } = this.state;
		if (rightButtonsSelected === SMELTERS_VIEW) {
			return this.buildSmelterView();
		} else if (rightButtonsSelected === YEARS_VIEW) {
			return this.buildYearsView();
		}
	};

	render() {
		return (
			<DocumentTitle title="GAINS | Production">
				<div className="content-wrapper">
					<Container fluid>
						<Crumbs type="al" path={[{ title: 'Production' }]} />
						{this.buildFilterForm()}
						{this.buildMainView()}
						{this.buildBottomView()}
					</Container>
				</div>
			</DocumentTitle>
		);
	}
}

const mapStateToProps = ({
	productionFactors,
	alSmelterProduction,
	alMtdProduction,
	alProductionBySmelter,
	alSelectedProdSmelters
}) => {
	for (const pf of productionFactors) {
		pf.key = pf.name.replace(/ /g, '').toLowerCase();
		if (pf.grouping === 'country') pf.grouping = 'countries';
		else if (pf.grouping === 'region') pf.grouping = 'regions';
		else if (pf.grouping === 'group') pf.grouping = 'groups';
	}

	return {
		regions: productionFactors,
		production: alSmelterProduction,
		pseudoGroupSmelters: alMtdProduction,
		productionSmelters: alProductionBySmelter,
		alSelectedProdSmelters
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchProductionFactors: (filterData) =>
		dispatch(fetchProductionFactors(filterData)),
	resetProductionFactors: () => dispatch(resetProductionFactors()),
	fetchAlSmelterProduction: (filterData) =>
		dispatch(fetchAlSmelterProduction(filterData)),
	resetAlSmelterProduction: () => dispatch(resetAlSmelterProduction()),
	fetchAlMtdProduction: (filterData) =>
		dispatch(fetchAlMtdProduction(filterData)),
	resetAlMtdProduction: () => dispatch(resetAlMtdProduction()),
	fetchAlProductionBySmelter: (filterData) =>
		dispatch(fetchAlProductionBySmelter(filterData)),
	resetAlProductionBySmelter: () => dispatch(resetAlProductionBySmelter()),
	selectAlProdSmelter: (key) => dispatch(selectAlProdSmelter(key)),
	resetAlProdSmelters: () => dispatch(resetAlProdSmelters())
});

export default connect(mapStateToProps, mapDispatchToProps)(SmeltersProduction);
